var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.43V11.82L9.72 14.1L12 15.43ZM20 15.43V5.42999H18.39L12.26 11.56L20 15.43ZM19.14 1.83999L17.73 0.429993L12.73 5.42999H9V8.42999L0 8.42999L6.15 12.01L2 16.16L3.41 17.57L19.14 1.83999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashOff);
export default __webpack_public_path__ + "static/media/flashOff.d02a6955ac74e8a5c73bd887b5c3fa3a.svg";
export { ForwardRef as ReactComponent };